function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#A107FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0005 17.5C14.1426 17.5 17.5005 14.1421 17.5005 10C17.5005 5.85786 14.1426 2.5 10.0005 2.5C5.85835 2.5 2.50049 5.85786 2.50049 10C2.50049 14.1421 5.85835 17.5 10.0005 17.5Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_705:430544)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.6773 7.38178L13.854 7.205L13.6773 7.02822L12.9723 6.32322L12.7955 6.14645L12.6187 6.32322L10.0005 8.94145L7.38226 6.32322L7.20549 6.14645L7.02871 6.32322L6.32371 7.02822L6.14693 7.205L6.32371 7.38178L8.94194 10L6.32371 12.6182L6.14693 12.795L6.32371 12.9718L7.02871 13.6768L7.20549 13.8536L7.38226 13.6768L10.0005 11.0586L12.6187 13.6768L12.7955 13.8536L12.9723 13.6768L13.6773 12.9718L13.854 12.795L13.6773 12.6182L11.059 10L13.6773 7.38178Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.5
}));

var SvgIconCancelled = function SvgIconCancelled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_705:430544",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 16,
    height: 16
  }, _ref3), _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCancelled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-cancelled.dcabc18d.svg";
export { ForwardRef as ReactComponent };